/**
 * Feather burst on bird hit. Uses hunt feather spritesheet when available.
 */
import { HUNT_SPRITE_SHEETS } from './huntConfig';
import { drawSpriteFrame } from './huntSprites';

export interface FeatherParticle {
    x: number;
    y: number;
    vx: number;
    vy: number;
    life: number;
    maxLife: number;
    frame: number;
    rotation: number;
    spin: number;
    size: number;
}

export function spawnFeathers(x: number, y: number, count = 8): FeatherParticle[] {
    const particles: FeatherParticle[] = [];
    for (let i = 0; i < count; i++) {
        const angle = Math.random() * Math.PI * 2;
        const speed = 1.5 + Math.random() * 3;
        particles.push({
            x,
            y,
            vx: Math.cos(angle) * speed,
            vy: Math.sin(angle) * speed - 1.5,
            life: 500 + Math.random() * 400,
            maxLife: 900,
            frame: Math.floor(Math.random() * HUNT_SPRITE_SHEETS.hitFeathers.frameCount),
            rotation: Math.random() * Math.PI,
            spin: (Math.random() - 0.5) * 0.2,
            size: 16 + Math.random() * 10,
        });
    }
    return particles;
}

export function updateFeathers(particles: FeatherParticle[], deltaMs: number): FeatherParticle[] {
    return particles
        .map((p) => ({
            ...p,
            x: p.x + p.vx,
            y: p.y + p.vy,
            vy: p.vy + 0.06,
            life: p.life - deltaMs,
            rotation: p.rotation + p.spin,
        }))
        .filter((p) => p.life > 0);
}

export function drawFeathers(
    ctx: CanvasRenderingContext2D,
    particles: FeatherParticle[],
    featherImg?: HTMLImageElement
): void {
    const sheet = HUNT_SPRITE_SHEETS.hitFeathers;
    particles.forEach((p) => {
        const alpha = Math.min(1, p.life / p.maxLife);
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.globalAlpha = alpha;

        if (featherImg?.complete && featherImg.naturalWidth > 0) {
            drawSpriteFrame(ctx, featherImg, sheet, p.frame, -p.size / 2, -p.size / 2, p.size, p.size);
        } else {
            ctx.fillStyle = '#fefae0';
            ctx.beginPath();
            ctx.ellipse(0, 0, p.size * 0.45, p.size * 0.2, 0, 0, Math.PI * 2);
            ctx.fill();
        }

        ctx.restore();
    });
    ctx.globalAlpha = 1;
}
